import { Component, OnInit, Inject } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { UserApi, CertificateDesignApi, CompanyApi, LoopBackAuth, CertificateApi } from '../../../services/shared/sdk';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as moment from 'moment';
import { FileUploader } from 'ng2-file-upload';
import { UUID } from 'angular2-uuid';
import { BASE_URL, API_VERSION, CONTAINER_FOLDER } from '../../../services/base-url';


@Component({
  selector: 'app-editar-certificado',
  templateUrl: './editar-certificado.component.html',
  styleUrls: ['./editar-certificado.component.scss']
})
export class EditarCertificadoComponent implements OnInit {
  form: FormGroup;
  uploadURL = BASE_URL + '/' + API_VERSION + CONTAINER_FOLDER + '/upload?access_token=' + this.loopBackAuth.getToken().id;
  uploader: FileUploader = new FileUploader({ url: this.uploadURL });
  image: any;
  cert = {
  image: null
}
  message = "";
  amount = 0;
  certImage;
  desing1 = null;
  desing2 = null;
  desing3 = null;
  desing4 = null;
  desings = [];
  indice = 0;
  index1 = 0;
  index2 = 1;
  index3 = 2;
  categoryId;
  img;

  constructor(
    public dialogRef: MatDialogRef<EditarCertificadoComponent>,
    private _snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private _desing: CertificateDesignApi,
    private _user: UserApi,
    private _company: CompanyApi,
    private _certificate: CertificateApi,
    private loopBackAuth: LoopBackAuth,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.form = this.formBuilder.group({
      amount: ['', Validators.required],
      message: ['', Validators.required],
      category: ['']
    }); 
    this.certImage = this.data.cert.imagen;
    this.amount= this.data.cert.value;
    this.message = this.data.cert.message;
    this.categoryId = this.data.cert.categoryId;
    this.selectCategory(this.data.cert.categoryId, true);
  }

  ngOnInit() {
    console.log(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectCategory(cat, init){    
    this.indice = 0;
    this.categoryId = init ? cat : cat.target.value;    
    this.desings = this.data.designs.filter((des) => {
      return des.categoryId == this.categoryId;
    });

    this.desing1 = this.desings[0] ? this.desings[0] : null;
    this.desing2 = this.desings[1] ? this.desings[1] : null;
    this.desing3 = this.desings[2] ? this.desings[2] : null;
    this.desing4 = this.desings[3] ? this.desings[3] : null;
  }

  selectImage(img){
    //console.log(img);
    if(img == "https://adminngift.s3-us-west-2.amazonaws.com/assets/images/welcome/bienvenido.png"){
      this.img = img
    }
    else{
      const image = img.split('/');
      this.img = image[image.length - 1];
    }
    this.certImage = img;
    console.log(this.img);
    console.log(this.certImage);
  }

  selectNext() {
    this.indice++;   
    if (this.desings[this.index1 + this.indice]) {
      this.desing1 = this.desings[0 + this.indice]
    } else {
      this.indice = -1;
      return this.selectNext();
    }
    if (this.desings[this.index2 + this.indice]) {
      this.desing2 = this.desings[1 + this.indice]
    } else {
      this.indice = -1;
      return this.selectNext();
    }
    if (this.desings[this.index3 + this.indice]) {
      this.desing3 = this.desings[2 + this.indice]
    } else {
      this.indice = -1;
      return this.selectNext();
    }
  }

  edit(){
    const cert = {
      companyId: this.data.companyId,
      value: this.amount,
      userId:null,
      categoryId: this.categoryId,
      message: this.message,
      img: this.img,
      isWelcome: true
    }

    console.log(cert);
    this._certificate.patchAttributes(this.data.cert.id, cert).subscribe((newcert) => {
      this.data.cert = newcert
      this.dialogRef.close(this.data);
    });
  }

  changeMessage(event){
    let plantilla = this.data.plantillas.find((plan) => plan.id == event.target.value);

    this.message = plantilla.description;    
    
  }

}
